import { render } from "./Update.vue?vue&type=template&id=7d3fcfc2"
import script from "./Update.vue?vue&type=script&lang=ts"
export * from "./Update.vue?vue&type=script&lang=ts"
script.render = render

export default script